import Vue from 'vue';

// Full version with all components included
import Vuetify from 'vuetify';

// Minimal version with only used components
//import Vuetify from 'vuetify/lib'

import en from 'vuetify/es5/locale/en'
import sv from 'vuetify/es5/locale/sv'

function getVuetify(config) {
    Vue.use(Vuetify);
    return new Vuetify({
        theme: {
            themes: {
                light: {
                    'zoezi-edit-color': getComputedStyle(document.documentElement).getPropertyValue('--zoezi-edit-color').trim(),
                    ...config?.root?.props?.colors
                }
            }
        },
        lang: {
            locales: { sv, en },
            current: 'sv',
        },
        breakpoint: {
            mobileBreakpoint: 'sm'
        }
    });
}

export { getVuetify }
